import { getDictPhrase } from "../../../common";
const notValidOdds = "0";
export const getBetTitleCastBetProps = (bet, state) => {
    return {
        name: getDictPhrase(state.dict, bet.type),
        odds: bet.displayOdds && bet.displayOdds !== notValidOdds ? bet.displayOdds : getDictPhrase(state.dict, "NotAvailable")
    };
};
//# sourceMappingURL=getBetTitleCastBetProps.js.map